export default __webpack_public_path__ + "static/media/pic.7a7c60e7.png";